/** @module Specification/CareAndComposition/ExceptionLanguageCompositionStringsController */
define([
	"dojo/_base/declare",
	"csi/store/Cache",
	"csi/store/Nodes",
	"csi/table/Widget",
	"csi/xml/Query"
], function(declare, Cache, Nodes, Table, Query) {

	const _languageStore = new Nodes({
		cachingStore: new Cache(),
		typeNode: "Language",
		sortQuery: new Query().SortByAttr("SortOrder")
	});

	return declare(Table, {
		/**
		 * @override
		 * Cache all languages in system - query only needs to be done once
		 */
		onViewStart(dfds) {
			const {cacheView} = this;
			const dfd = _languageStore.query();

			this.when(dfd, (results) => {
				results.forEach((result) => {
					cacheView.cacheNode(result);
				});
			});

			dfds.push(dfd);
		},

		/**
		 * @override
		 * Filter languages by languages from the CareAndCompositionRevision.CompositionLines exception list
		 */
		onCreateMainQueryLevel(ql) {
			ql.createCustomStore = () => {
				const {CompositionLines} = this.getViewNode();
				const data = _languageStore.query().filter((item) => CompositionLines[item.SysID]);

				return new Nodes({
					cachingStore: this.cacheView,
					data
				});
			};
		}
	});
});